// import dJSON from 'dirty-json';
// import '../node_modules/@lottiefiles/lottie-player/dist/lottie-player';

import './js/base/base-start';
import './js/global';

// modules - core
import './modules/core/accordion/module';

// modules
import './modules/theme/custom-message/module';
import './modules/theme/sign-in-buttons/module';
import './modules/theme/features-usp/module';
import './modules/theme/popular-items/module';
import './modules/theme/brands-slider/module';

// layouts

// leave me last
import './js/base/base-end';
